// Kartadagi QR (`<portal>/v#<kod>` yoki `/v#t.<token>`) hotspot portali ochilguncha shu tabning
// sessionStorage'ida 30 daqiqa kutadi; kirish berilishi yoki karta rad etilishi bilan o'chadi.
import { normalizeQrToken, normalizeVoucherCode, type VoucherCard } from './voucherCard'

const STORAGE_KEY = 'xsib.pendingVoucher'
const TTL_MS = 30 * 60 * 1000

export type KeyValueStore = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>

interface StoredCard {
  code?: unknown
  token?: unknown
  savedAt?: unknown
}

export function savePendingVoucher(store: KeyValueStore | null, card: VoucherCard, now = Date.now()): boolean {
  if (!store) return false
  const value = card.kind === 'token' ? { token: card.token, savedAt: now } : { code: card.code, savedAt: now }
  try {
    store.setItem(STORAGE_KEY, JSON.stringify(value))
    return true
  } catch {
    return false
  }
}

export function readPendingVoucher(store: KeyValueStore | null, now = Date.now()): VoucherCard | null {
  if (!store) return null
  try {
    const raw = store.getItem(STORAGE_KEY)
    if (raw === null) return null
    const parsed: unknown = JSON.parse(raw)
    const stored = typeof parsed === 'object' && parsed !== null ? (parsed as StoredCard) : {}
    const card = storedCard(stored)
    const savedAt = stored.savedAt
    if (card === null || typeof savedAt !== 'number' || now - savedAt > TTL_MS || savedAt > now) {
      store.removeItem(STORAGE_KEY)
      return null
    }
    return card
  } catch {
    return null
  }
}

export function clearPendingVoucher(store: KeyValueStore | null): void {
  try {
    store?.removeItem(STORAGE_KEY)
  } catch {
    // saqlab bo'lmagan joydan o'chirish ham shart emas
  }
}

function storedCard(stored: StoredCard): VoucherCard | null {
  if (typeof stored.token === 'string') {
    const token = normalizeQrToken(stored.token)
    return token ? { kind: 'token', token } : null
  }
  if (typeof stored.code === 'string') {
    const code = normalizeVoucherCode(stored.code)
    return code ? { kind: 'code', code } : null
  }
  return null
}

const REJECTED_CARD_TAGS = new Set([
  'VOUCHER_ACTIVATED',
  'VOUCHER_EXPIRED',
  'VOUCHER_VOIDED',
  'VOUCHER_NOT_FOUND',
  'VOUCHER_UNUSABLE',
])

/**
 * Bu karta shu tarmoqda endi hech qachon o'tmaydi: karta rad etilgan (409 + karta tegi) yoki zona
 * bu usulni qabul qilmaydi (422). Tarmoq xatosi, 429 va 503 — vaqtinchalik, karta saqlanib qoladi.
 */
export function isDefinitiveVoucherFailure(status: number | null, tag: string | null): boolean {
  if (status === 422) return true
  return status === 409 && tag !== null && REJECTED_CARD_TAGS.has(tag)
}
